var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3084_3253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 44.5097C73.3332 53.533 66.9085 61.0737 58.3332 62.9073M20.9522 63.3333C13.0624 63.3333 6.6665 57.0127 6.6665 49.2157C6.6665 41.4187 13.0624 35.098 20.9522 35.098C21.8993 35.098 22.8248 35.189 23.7204 35.363M23.7204 35.363C22.9567 33.326 22.5395 31.1229 22.5395 28.8235C22.5395 18.4276 31.0674 10 41.5872 10C51.3862 10 59.4568 17.3124 60.5168 26.7166M23.7204 35.363C25.6018 35.728 27.3508 36.458 28.8887 37.4753M47.9365 26.7574C49.9222 26.0637 52.0592 25.6863 54.2855 25.6863C56.4678 25.6863 58.5642 26.0489 60.5168 26.7166M60.5168 26.7166C62.7935 27.4951 64.8742 28.6883 66.6665 30.2047",
    stroke: "#1C274C",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 66L37.1432 70L46.6668 60",
    stroke: "#1C274C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3084_3253)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -62.9331,
    y: -51.2,
    width: 157.867,
    height: 157.867,
    fill: "#5FCFE7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.1b59c68d1c34fad291e8d1bb3e5a43d7.svg";
export { ForwardRef as ReactComponent };